<div class="container layout-row align-between responsive-column">
  <mat-card class="flex-100">
    <mat-card-content class="flex-100">
      <div class="layout-row flex-100">
        <div class="flex-46">
          <div class="layout-row-wrap">
            <div class="flex-50 mat-body-strong">
              {{ 'labels.inputs.ID' | translate }}
            </div>

            <div class="flex-50">
              {{ auditTrailData.id }}
            </div>

            <div class="flex-50 mat-body-strong">
              {{ 'labels.inputs.Status' | translate }}
            </div>

            <div class="flex-50">
              {{ auditTrailData.processingResult }}
            </div>

            <div class="flex-50 mat-body-strong">
              {{ 'labels.inputs.User' | translate }}
            </div>

            <div class="flex-50">
              {{ auditTrailData.maker }}
            </div>

            <div class="flex-50 mat-body-strong">
              {{ 'labels.inputs.Action' | translate }}
            </div>

            <div class="flex-50">
              {{ auditTrailData.actionName }}
            </div>

            <div class="flex-50 mat-body-strong">
              {{ 'labels.inputs.Entity' | translate }}
            </div>

            <div class="flex-50">
              {{ auditTrailData.entityName }}
            </div>

            <div class="flex-50 mat-body-strong">
              {{ 'labels.inputs.Resource ID' | translate }}
            </div>

            <div class="flex-50">
              {{ auditTrailData.resourceId }}
            </div>

            <div class="flex-50 mat-body-strong">
              {{ 'labels.inputs.Date' | translate }}
            </div>

            <div class="flex-50">
              {{ auditTrailData.madeOnDate | datetimeFormat }}
            </div>

            @if (auditTrailData.officeName) {
              <div class="flex-50 mat-body-strong">
                {{ 'labels.inputs.Office' | translate }}
              </div>
            }

            @if (auditTrailData.officeName) {
              <div class="flex-50">
                {{ auditTrailData.officeName }}
              </div>
            }

            @if (auditTrailData.savingsAccountNo) {
              <div class="flex-50 mat-body-strong">
                {{ 'labels.inputs.Savings Account No' | translate }}
              </div>
            }

            @if (auditTrailData.savingsAccountNo) {
              <div class="flex-50">
                {{ auditTrailData.savingsAccountNo }}
              </div>
            }

            @if (auditTrailData.groupLevelName) {
              <div class="flex-50 mat-body-strong">
                {{ 'labels.inputs.Group Level' | translate }}
              </div>
            }

            @if (auditTrailData.groupLevelName) {
              <div class="flex-50">
                {{ auditTrailData.groupLevelName }}
              </div>
            }
          </div>

          @if (auditTrailData.ip) {
            <div fxFlex="50%" class="mat-body-strong">
              {{ 'labels.inputs.Client Ip' | translate }}
            </div>
          }

          @if (auditTrailData.ip) {
            <div fxFlex="50%">
              {{ auditTrailData.ip }}
            </div>
          }
        </div>

        <div class="flex-46 command">
          <table mat-table [dataSource]="dataSource" class="command-table" matSort>
            <ng-container matColumnDef="command">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'labels.inputs.Command' | translate }}</th>
              <td mat-cell *matCellDef="let auditTrailCommand">{{ auditTrailCommand.command }}</td>
            </ng-container>

            <ng-container matColumnDef="commandValue">
              <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Command Value' | translate }}</th>
              <td mat-cell *matCellDef="let auditTrailCommand" class="column-value-wrapper">
                {{ auditTrailCommand.commandValue }}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </div>
      </div>

      <div class="layout-row layout-align-center m-t-20 column-on-mobile">
        <button type="button" mat-raised-button color="primary" [routerLink]="['../']">
          {{ 'labels.buttons.Back' | translate }}
        </button>
      </div>
    </mat-card-content>
  </mat-card>
</div>
